import { AuthContext } from 'Modules/Auth/contexts/AuthContext';
import { CREATORBASE_ROOT_PATH } from 'Modules/Navigation/whitelabel/routes';
import { CURRENT_APP, redirectToApp } from 'Modules/Navigation/whitelabel/appRouting';
import useCurrentUserClients from 'Modules/Plans/Clients/hooks/useCurrentUserClients';
import { resolveTargetApp } from '@round/creatorbase-helpers';
import { useContext } from 'react';
import { Navigate } from 'react-router-dom';

const RedirectToDefault = () => {
    const authContext = useContext(AuthContext);
    const { clients, status } = useCurrentUserClients();

    if (authContext.loading) {
        return null;
    }

    if (!authContext.user) {
        return <Navigate to="/login/" replace />;
    }

    // Legacy (non-creatorbase) round users keep their existing home.
    if (!authContext.user.creator_base_access) {
        return <Navigate to="/campaigns/" replace />;
    }

    // Never redirect on unsettled data: wait for the client list so resolveTargetApp is sound. A
    // failed fetch falls through to the creatorbase home, where the auth wrapper surfaces the error.
    if (status === 'loading') {
        return null;
    }

    if (status === 'success') {
        const targetApp = resolveTargetApp({ clients, currentApp: CURRENT_APP });
        // redirectToApp returns false if the target URL is misconfigured to this origin; fall through.
        if (targetApp !== CURRENT_APP && redirectToApp(targetApp)) {
            return null;
        }
    }

    return <Navigate to={`/${CREATORBASE_ROOT_PATH}/projects/`} replace />;
};

export default RedirectToDefault;
